import { fetch } from '@atlassian/eoc-fetch';

export type DownloadFileData = {
	// Stored as text (serializable) rather than Blob so react-resource-router
	// can safely cache the resource without losing data through JSON serialization.
	// The component converts this to a data URI when triggering the download.
	content: string;
	filename: string;
};

const getFilenameFromContentDisposition = (contentDisposition: string | null): string | null => {
	if (!contentDisposition) {
		return null;
	}
	const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
	if (match && match[1]) {
		return match[1].replace(/['"]/g, '').replace(/\//g, '-');
	}
	return null;
};

export const fetchDownloadLinkEndpoint = async (
	exportUniqueKey: string,
): Promise<DownloadFileData> => {
	const response = await fetch<Response>(`/v1/logs/export/${exportUniqueKey}/download`, {
		responseType: 'headers',
	});
	const content = await (response as Response).text();
	const contentDisposition = (response as Response).headers?.get('content-disposition');
	const filenameFromHeader = getFilenameFromContentDisposition(contentDisposition);
	const now = new Date();
	const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(
		now.getDate(),
	).padStart(2, '0')}`;
	const timeStr = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(
		2,
		'0',
	)}`;
	const filename = filenameFromHeader ?? `Audit_logs_${dateStr}-${timeStr}.csv`;
	return { content, filename };
};
